import React, { useState, useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Button, Select, Form, Input, Card, message } from "antd";
import { EyeOutlined, EyeInvisibleOutlined } from "@ant-design/icons";
import { Link } from "react-router-dom";
import { UserContext } from "../UserContext";

const Login = () => {
	const [form] = Form.useForm();
	const navigate = useNavigate();
	const [showPassword, setShowPassword] = useState(false);
	const [loading, setLoading] = useState(false);
	const [messageApi, contextHolder] = message.useMessage();
	const [apiuri, setApiuri] = useState("");
	const { instructorapiuri, handleLogin, studentapiuri } =
		useContext(UserContext);


	const [role, setRole] = useState(null);

	const togglePasswordVisibility = () => {
		setShowPassword(!showPassword);
	};

	useEffect(() => {
		if (role === "s") {
			setApiuri(studentapiuri);
		} else {
			setApiuri(instructorapiuri);
		}
	}, [role, studentapiuri, instructorapiuri]);

	const handleAuthentication = async () => {
		try {
			const values = await form.validateFields();
			setLoading(true);

			const response = await fetch(`${apiuri}/auth/login`, {
				method: "POST",
				headers: {
					"Content-Type": "application/json",
				},
				body: JSON.stringify(values),
			});

			const data = await response.json();
			// console.log(data);
			handleLogin(data.token,data.user.role);

			if (role === "t") {
				navigate("/teacher/home");
			} else if (role === "s") {
				navigate("/student/home");
			}
		} catch (error) {
			console.error("Form validation failed", error);
			setLoading(false);
		}
	};

	return (
		<>
			<div className="bg signup-comp">
				<Card className="innercard">
					<div className="grid-2">
						<div className="centerdflex">
							<center>
								<h1>Login</h1>
							</center>

							<Form
								form={form}
								className="form-cont"
								layout="vertical"
								initialValues={{
									remember: true,
								}}
								onFinish={handleAuthentication}
								autoComplete="off">
								<Form.Item
									label="Email"
									name="email"
									rules={[
										{
											required: true,
											message: "Please input your username!",
										},
									]}>
									<Input className="inp" />
								</Form.Item>
								<Form.Item
									label="Role"
									name="role"
									rules={[
										{
											required: true,
											message: "Please input your username!",
										},
									]}>
									<Select options={[
											{
											value: 't',
											label: 'Teacher',
											},
											{
											value: 's',
											label: 'Student',
											}]} onChange={e => setRole(e)} />
								</Form.Item>
								<Form.Item
									label="Password"
									name="password"
									rules={[
										{
											required: true,
											message: "Please input your password!",
										},
									]}>
									<Input
										type={showPassword ? "text" : "password"}
										className="inp"
									/>
								</Form.Item>

								<Button
									type="text"
									className="showbt"
									icon={
										showPassword ? <EyeOutlined /> : <EyeInvisibleOutlined />
									}
									onClick={togglePasswordVisibility}
								/>
								<div className="forgotpass">
									<Link to="/forgot">Forgot Password</Link>
								</div>
								<br />
								<div className="adjust">
									<label htmlFor="Login">Don't have an account? &nbsp;</label>
									<Link id="signup" to="/signup" className="a">
										Create One
									</Link>
								</div>
								<br />
								<Form.Item className="sub-btn">
									<Button type="primary" htmlType="submit">
										Submit
									</Button>
								</Form.Item>
							</Form>
						</div>
					</div>
				</Card>
			</div>

			{contextHolder}
		</>
	);
};

export default Login;
